import { Component, ElementRef, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Subject, from } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { PAGES_AND_PATHS } from 'src/app/constants/pages-and-paths';
import { TlPagination } from 'src/app/interfaces/general-interfaces';
import { ItemsHttpService } from 'src/app/services/http-services/items/items-http.service';
import { ListsHttpService } from 'src/app/services/http-services/lists/lists-http.service';

@Component({
  selector: 'app-favorite-items',
  templateUrl: './favorite-items.component.html',
})
export class FavoriteItemsComponent {
  favoriteItems: any[] = [];
  pagination!: TlPagination;
  pageNum = 1;
  loading = false;
  private searchSubject = new Subject<string>();
  searchTerm = '';
  PAGES_AND_PATHS = PAGES_AND_PATHS;
  @ViewChild('favoriteItemsContainter', { static: false }) private favoriteItemsContainter!: ElementRef;

  constructor(
    private listsHttpService: ListsHttpService,
    private toastService: ToastrService,
    private itemsHttpService: ItemsHttpService
  ) { }

  ngOnInit(): void {
    this.getFavoriteItemsV2();
    this.searchSubject.pipe(
      debounceTime(300),
      switchMap((searchTerm: string) => from(this.getFavoriteItemsV2(searchTerm)))
    ).subscribe(response => {
      this.favoriteItems = response.data;
      this.pagination = response.pagination;
    });
  }

  getFavoriteItemsV2(searchTerm?: string) {
    this.loading = true;
    return (
      this.listsHttpService.getFavoriteItemsV2(this.pageNum, searchTerm).then((response: any) => {
        this.favoriteItems = [...this.favoriteItems, ...response.data];
        this.pagination = response.pagination;
        return response;
      })
    );
  }

  addItemToFavorites(item: any): void {
    this.itemsHttpService.addItemToFavorites(item.id).then((res: any) => {
      this.toastService.success(res.message);
      const index = this.favoriteItems.findIndex(itemObj => itemObj.id === item.id);
      this.favoriteItems[index].am_i_favorite_this_lyst_item = !this.favoriteItems[index].am_i_favorite_this_lyst_item;
    });
  }

  onScroll(): void {
    const container = this.favoriteItemsContainter.nativeElement;
    const scrollTop = container.scrollTop;
    const scrollHeight = container.scrollHeight;
    const clientHeight = container.clientHeight;

    const isAtBottom = scrollTop + clientHeight >= scrollHeight - 100;

    if (!this.loading && isAtBottom && ((this.pagination?.currentPage ?? 0) < (this.pagination?.lastPage ?? 0))) {
      this.pageNum++;
      this.getFavoriteItemsV2();
    }
  }

  onSearchChange(event: any): void {
    this.searchTerm = event.target.value;
    this.pageNum = 1;
    this.searchSubject.next(this.searchTerm);
  }

  resetSearch() {
    this.searchTerm = '';
    this.searchSubject.next('');
  }
}
